/**
 * In-memory buildings energy fetch cache. Leaf module so LocationContext can clear
 * on location change without importing buildingsEnergyDataService (heavy dep graph).
 */

export const BUILDINGS_ENERGY_CACHE_TTL_MS = 5 * 60 * 1000;

type CacheEntry = { data: unknown; timestamp: number };

const cache = new Map<string, CacheEntry>();

export function getBuildingsEnergyCacheEntry(location: string): CacheEntry | undefined {
  return cache.get(location);
}

export function setBuildingsEnergyCacheEntry(location: string, data: unknown): void {
  cache.set(location, { data, timestamp: Date.now() });
}

export function deleteBuildingsEnergyCacheEntry(location: string): void {
  cache.delete(location);
}

/** Clear cached fetch results for one location or all locations. */
export function clearBuildingsEnergyCache(location?: string): void {
  if (location) {
    cache.delete(location);
  } else {
    cache.clear();
  }
}
